"use client";

import { Language } from "@ellaandil/ui";
import { clsx } from "@trydig/ui";
import type { ComponentProps } from "react";
import { Typography } from "@/components/ui/Typography";
import { countries, useGeo } from "@/i18n/routing";

export interface GeoStatusProps extends ComponentProps<"button"> {
  disableTextPadding?: boolean;
}

export const GeoStatus = ({
  disableTextPadding,
  className,
  ...props
}: GeoStatusProps) => {
  const { country, language } = useGeo();
  const realCountry = countries.find((c) => c.country === country);
  return (
    <button
      type="button"
      className={clsx("flex gap-1 items-center", className)}
      {...props}
    >
      <Language height={24} width={24} />
      <Typography
        variant="heading-display-sm"
        className={clsx(" text-sm", !disableTextPadding && "p-[6px]")}
      >
        {language} / {realCountry?.currency}
      </Typography>
    </button>
  );
};
